import React  from 'react';
import PropTypes from 'prop-types';
import {
  StyledCreditCardDetails,
} from './StyledCreditCardDetails';
import {WithLessCreditCardIcon} from '../../../../icons';
import {cardsHelpers} from '../../../../utils/helpers';


const CreditCardDetails = ({
  cardNumberClassName = '',
  cardNumber,
  ...rest
}) => {

  return (
    <StyledCreditCardDetails
      {...rest}
      align='center'
      size='small'
    >
      <WithLessCreditCardIcon />
      <span className={cardNumberClassName}>{cardsHelpers.hideCardNumber(cardNumber)}</span>
    </StyledCreditCardDetails>
  );
}

CreditCardDetails.propTypes = {
  cardNumberClassName: PropTypes.string,
  cardNumber: PropTypes.string
}

export default CreditCardDetails;
